var isNumber = require('../type/is-number');

var isEven = function isEven(num) {
  return isNumber(num) && num % 2 === 0;
};

module.exports = isEven;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@antv/util/lib/math/is-even.js
// module id = 296
// module chunks = 0 1 2